<template>
  <v-row align="end" style="height: calc(100vh - 150px);">
    <v-col >
    <v-carousel hide-delimiter-background :show-arrows="false" height="200px"  >
      <v-carousel-item v-for="(mensaje, i) in mensajes" :key="i">
        <v-sheet color="transparent" tile style="position: absolute; bottom: 40px; width:100%;">
          <v-row justify="center">
            <div style="padding:20px; text-align: center;">{{ mensaje }}</div>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <v-row dense>
      <v-col>
        <v-btn color="pink" dark block x-large @click="showDialog">Registrate ahora</v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-btn
          dark
          block
          large
          text
          style="text-transform:none;font-weight:400"
          to="/login/form"
        >¿Ya eres Clubber? Inicia sesión</v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Registro</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="hideDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form autocomplete="off" class="mt-2">
            <v-text-field
              color="pink"
              v-model="name"
              :rules="nameRules"
              label="Nombre"
              required
              autocomplete="off"
            ></v-text-field>
            <v-text-field
              color="pink"
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              required
              autocomplete="off"
            ></v-text-field>
            <v-text-field
              color="pink"
              v-model="password"
              type="password"
              label="Contraseña"
              required
              autocomplete="new-password"
            ></v-text-field>
            <v-text-field
              color="pink"
              v-model="passrepeat"
              type="password"
              label="Repetir contraseña"
              required
              autocomplete="new-password"
            ></v-text-field>
            <v-btn block text color="pink" dark class="center">Aceptar</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      mensajes: [
        "Forma parte de la comunidad",
        "Recarga el saldo de tu pulsera sin hacer colas, al instante",
        "Mantente informado de los eventos"
      ],
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      valid: true,
      name: "",
      password: "",
      passrepeat: "",
      nameRules: [v => !!v || "El nombre es obligatorio"],
      email: "",
      emailRules: [
        v => !!v || "El e-mail es obligatorio",
        v => /.+@.+\..+/.test(v) || "El e-mail no es válido"
      ]
    };
  },
  methods: {
    showDialog() {
      this.dialog = true;
    },
    hideDialog() {
      this.dialog = false;
    }
  }
};
</script>

<style>
</style>